import { CreateTenantUserDto } from "./create.dto";

export class UpdateTenantUserDto extends CreateTenantUserDto {
  id: string;
  isActive?: boolean;

  constructor(params: Partial<CreateTenantUserDto>) {
    super();
    Object.assign(this, params);
  }
}
